export default {
	agent_gateway_auth_required: 'Bitte melden Sie sich erneut an.',
	agent_gateway_instance_database_not_configured: 'Für diese Instanz ist kein Agent-Gateway-Speicher konfiguriert.',
	agent_gateway_invalid_memory_input: 'Bitte prüfen Sie die Memory-Angaben.',
	agent_gateway_invalid_provider_input: 'Bitte prüfen Sie die Provider-Angaben.',
	agent_gateway_memory_conflict: 'Die Memory-Seite wurde inzwischen geändert.',
	agent_gateway_memory_forbidden: 'Für diese Memory-Aktion fehlen die notwendigen Rechte.',
	agent_gateway_memory_not_found: 'Die Memory-Seite wurde nicht gefunden.',
	agent_gateway_provider_base_url_rejected: 'Die Provider-URL ist aus Sicherheitsgründen nicht erlaubt.',
	agent_gateway_provider_capability_unsupported: 'Der Provider unterstützt diese Agent-Anfrage nicht.',
	agent_gateway_provider_conflict: 'Ein Provider mit diesem Namen existiert bereits.',
	agent_gateway_provider_explorer_structured_output_unsupported: 'Der Explorer benötigt strukturierte Ausgabe.',
	agent_gateway_provider_explorer_tool_use_unsupported: 'Der Explorer benötigt Werkzeugnutzung.',
	agent_gateway_provider_forbidden: 'Für diese Provider-Aktion fehlen die notwendigen Rechte.',
	agent_gateway_provider_memory_metadata_frontier_denied:
		'Speicher-Metadaten dürfen nicht an Frontier-Provider gesendet werden.',
	agent_gateway_provider_memory_requires_exact_local:
		'Diese Speicheranfrage benötigt einen lokalen Provider ohne Fallback.',
	agent_gateway_provider_memory_summary_frontier_denied:
		'Speicher-Zusammenfassungen dürfen nicht an Frontier-Provider gesendet werden.',
	agent_gateway_provider_not_found: 'Der Provider wurde nicht gefunden.',
	agent_gateway_provider_preparer_structured_output_unsupported: 'Der Preparer benötigt strukturierte Ausgabe.',
	agent_gateway_provider_structured_output_unsupported: 'Der Provider unterstützt keine strukturierte Ausgabe.',
	agent_gateway_provider_tier_conflict: 'Die Tier-Zuordnung ist nicht eindeutig.',
	agent_gateway_provider_tier_frontier_duplicate: 'Es gibt mehr als einen aktiven Frontier-Provider.',
	agent_gateway_provider_tier_frontier_unavailable: 'Es ist kein Frontier-Provider verfügbar.',
	agent_gateway_provider_tier_local_duplicate: 'Es gibt mehr als einen aktiven lokalen Provider.',
	agent_gateway_provider_tier_local_unavailable: 'Es ist kein lokaler Provider verfügbar.',
	agent_gateway_provider_tier_unavailable: 'Für dieses Tier ist kein Provider verfügbar.',
	agent_gateway_unknown_error: 'Das Agent-Gateway konnte die Anfrage nicht verarbeiten.',
	mail_rules_auto_delegate_empty_caption: 'Erstellen Sie eine neue Delegationsregel über den Button oben rechts.',
	mail_rules_auto_delegate_empty_title: 'Keine Delegationsregeln vorhanden',
	mail_rules_blacklist_empty_caption:
		'Adressen können direkt aus einer E-Mail heraus auf die Blacklist gesetzt werden.',
	mail_rules_blacklist_empty_title: 'Blacklist ist leer',
	mail_rules_no_archive_empty_caption: 'Fügen Sie eine Adresse über den Button oben rechts hinzu.',
	mail_rules_no_archive_empty_title: 'Keine ausgeblendeten Adressen vorhanden',
	mail_rules_remove_spam_empty_caption: 'Einträge entstehen, wenn Sie in einer E-Mail die Spammarkierung entfernen.',
	mail_rules_remove_spam_empty_title: 'Keine Regeln vorhanden',
	mail_rules_spam_empty_caption: 'Erstellen Sie eine neue Regel über den Button oben rechts.',
	mail_rules_spam_empty_title: 'Keine Spam-Regeln vorhanden',
	oauth_authorize_invalid_request_error:
		'Die Autorisierungsanfrage ist ungültig. Prüfen Sie den Link und versuchen Sie es erneut.',
	oauth_authorize_loading: 'Autorisierungsanfrage wird geprüft...',
	oauth_authorize_login_required_error:
		'Für diese Anfrage ist eine Anmeldung erforderlich. Melden Sie sich erneut an und versuchen Sie es noch einmal.',
	oauth_authorize_redirect_error:
		'Der Autorisierungsendpunkt hat unerwartet weitergeleitet. Bitte versuchen Sie es erneut.',
	oauth_authorize_retry_button: 'Erneut versuchen',
	oauth_authorize_temporarily_unavailable_error:
		'Der Autorisierungsdienst ist vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.',
	oauth_authorize_title: 'Anwendungszugriff autorisieren',
	oauth_authorize_unknown_error:
		'Die Autorisierungsanfrage konnte nicht abgeschlossen werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
	oauth_consent_approve_button: 'Zugriff erlauben',
	oauth_consent_client_label: 'Anwendung',
	oauth_consent_client_unverified: 'ungeprüfter Name',
	oauth_consent_deny_button: 'Ablehnen',
	oauth_consent_description: '{clientName} möchte auf diese Instanz zugreifen.',
	oauth_consent_ineligible_message:
		'OAuth-/MCP-Zugriff ist für Ihren Benutzer auf dieser Instanz nicht freigeschaltet; wenden Sie sich an Ihre Administration.',
	oauth_consent_load_error: 'Die Zugriffsanfrage konnte nicht geladen werden. Prüfen Sie den Link und laden Sie neu.',
	oauth_consent_loading: 'Zugriffsanfrage wird geladen...',
	oauth_consent_redirect_label: 'Antwort geht an',
	oauth_consent_redirect_unknown: 'unbekannt — diese Instanz meldet das Antwortziel noch nicht',
	oauth_consent_resource_label: 'MCP-Ressource',
	oauth_consent_retry_button: 'Erneut versuchen',
	oauth_consent_submit_error: 'Ihre Entscheidung konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
	oauth_consent_title: 'MCP-/API-Zugriff erlauben',
	oauth_instance_invalid_error:
		'Die angegebene Instanz ist ungültig. Prüfen Sie den Link und versuchen Sie es erneut.',
	oauth_instance_unknown_error:
		'Die angegebene Instanz wurde nicht gefunden oder ist nicht erreichbar. Prüfen Sie den Instanznamen und versuchen Sie es erneut.',
	setting_user_online_list_view_mode_compressed_label: 'Komprimierte Ansicht',
	setting_user_online_list_view_mode_large_label: 'Große Ansicht',
	settings_about_city: '59557 Lippstadt',
	settings_about_close_button_label: 'OK',
	settings_about_company_name: 'NETZkultur Informationssysteme GmbH',
	settings_about_court: 'Amtsgericht Paderborn',
	settings_about_email_label: 'E-Mail: ',
	settings_about_email_value: 'kontakt@netzkultur.de',
	settings_about_managing_director: 'Geschäftsführer: Ino Holling',
	settings_about_office_hours: 'Bürozeiten: Montag bis Freitag von 8:00 bis 17:30 Uhr',
	settings_about_phone_label: 'Tel.: ',
	settings_about_phone_value: '+49 29 41 - 27 263 - 0',
	settings_about_privacy_label: 'Datenschutz',
	settings_about_section_description: 'Versionsinformationen, Hinweise und Hintergrund zur App.',
	settings_about_street: 'Hansastr. 23',
	settings_about_tab: 'Über',
	settings_about_tax_id: 'USt.-IdNr.: DE233203591',
	settings_about_terms_label: 'Unsere Allgemeinen Geschäftsbedingungen',
	settings_about_trade_register: 'Handelsregister: HRB 6334',
	settings_about_website_label: 'Internet: ',
	settings_about_website_value: 'www.netzkultur.de',
	settings_agent_memory_archive_label: 'Archivieren',
	settings_agent_memory_backlinks_label: 'Backlinks',
	settings_agent_memory_context_layer_label: 'Kontext-Layer',
	settings_agent_memory_delete_label: 'Löschen',
	settings_agent_memory_description: 'Verwalten Sie private Markdown-Memory-Seiten für den Agenten.',
	settings_agent_memory_empty_hint: 'Legen Sie eine private Memory-Seite an oder suchen Sie nach bestehenden Seiten.',
	settings_agent_memory_empty_title: 'Keine Memory-Seiten vorhanden',
	settings_agent_memory_error_generic: 'Die Memory-Seiten konnten nicht verarbeitet werden.',
	settings_agent_memory_group_title: 'Memory',
	settings_agent_memory_include_archived_label: 'Archivierte Seiten einbeziehen',
	settings_agent_memory_link_broken: 'Kaputter Link',
	settings_agent_memory_links_label: 'Links',
	settings_agent_memory_markdown_label: 'Markdown',
	settings_agent_memory_new_label: 'Neu',
	settings_agent_memory_path_label: 'Pfad',
	settings_agent_memory_portable_category_label: 'Portable Category',
	settings_agent_memory_preview_label: 'Vorschau',
	settings_agent_memory_privacy_state_label: 'Privacy Review State',
	settings_agent_memory_refresh_label: 'Aktualisieren',
	settings_agent_memory_save_label: 'Speichern',
	settings_agent_memory_save_success: 'Memory-Seite wurde gespeichert.',
	settings_agent_memory_search_label: 'Suche',
	settings_agent_memory_section_description: 'Private Memory-Seiten durchsuchen, bearbeiten und archivieren.',
	settings_agent_memory_status_active: 'Aktiv',
	settings_agent_memory_status_archived: 'Archiviert',
	settings_agent_memory_tab: 'Agent — Memory',
	settings_agent_memory_tags_label: 'Tags (kommagetrennt)',
	settings_agent_memory_title_label: 'Titel',
	settings_agent_memory_unarchive_label: 'Wiederherstellen',
	settings_agent_provider_api_key_keep_hint: 'Leer lassen, um den vorhandenen Schlüssel beizubehalten.',
	settings_agent_provider_api_key_label: 'API-Schlüssel',
	settings_agent_provider_api_key_new_hint: 'Der Schlüssel wird nur auf dem Server gespeichert.',
	settings_agent_provider_archive_cancel_label: 'Abbrechen',
	settings_agent_provider_archive_confirm_label: 'Archivieren',
	settings_agent_provider_archive_confirm_message: 'Soll dieser Provider archiviert werden?',
	settings_agent_provider_archive_confirm_title: 'Provider archivieren',
	settings_agent_provider_archive_label: 'Archivieren',
	settings_agent_provider_archive_success: 'Provider wurde archiviert.',
	settings_agent_provider_base_url_label: 'Basis-URL',
	settings_agent_provider_capability_structured_output: 'Strukturierte Ausgabe',
	settings_agent_provider_capability_tool_use: 'Werkzeugnutzung',
	settings_agent_provider_context_window_hint:
		'Optional. Wird zur automatischen Ableitung des Nachrichtenbudgets verwendet.',
	settings_agent_provider_context_window_label: 'Kontextfenster (Tokens)',
	settings_agent_provider_default_model_hint:
		'Modelle werden aus dem gespeicherten Provider geladen; freie Eingabe ist möglich.',
	settings_agent_provider_default_model_label: 'Standardmodell',
	settings_agent_provider_display_name_label: 'Name',
	settings_agent_provider_empty_hint: 'Legen Sie einen eigenen oder instanzweiten Provider an.',
	settings_agent_provider_empty_title: 'Keine Provider vorhanden',
	settings_agent_provider_enabled_label: 'Provider aktiv',
	settings_agent_provider_error_generic: 'Die Provider konnten nicht verarbeitet werden.',
	settings_agent_provider_grants_description:
		'Wählen Sie die Benutzer aus, die diesen instanzverwalteten Provider verwenden dürfen.',
	settings_agent_provider_grants_no_users: 'Keine Benutzer gefunden',
	settings_agent_provider_grants_save_label: 'Freigaben speichern',
	settings_agent_provider_grants_save_success: 'Provider-Freigaben wurden gespeichert.',
	settings_agent_provider_grants_title: 'Benutzerfreigaben',
	settings_agent_provider_grants_users_label: 'Freigegebene Benutzer',
	settings_agent_provider_message_limit_hint:
		'Optional. Überschreibt das automatisch abgeleitete Limit pro Provider-Nachricht.',
	settings_agent_provider_message_limit_label: 'Nachrichtenlimit (Zeichen)',
	settings_agent_provider_new_label: 'Neu',
	settings_agent_provider_no_default_model: 'Kein Standardmodell',
	settings_agent_provider_refresh_label: 'Aktualisieren',
	settings_agent_provider_save_label: 'Speichern',
	settings_agent_provider_save_success: 'Provider wurde gespeichert.',
	settings_agent_provider_scope_instance_managed: 'Instanz',
	settings_agent_provider_scope_label: 'Gültigkeit',
	settings_agent_provider_scope_user_owned: 'Eigener Provider',
	settings_agent_provider_test_failed: 'Verbindung fehlgeschlagen',
	settings_agent_provider_test_invalid: 'Zugangsdaten ungültig',
	settings_agent_provider_test_label: 'Verbindung testen',
	settings_agent_provider_test_valid: 'Verbindung erfolgreich',
	settings_agent_provider_tier_alias_frontier: 'Frontier',
	settings_agent_provider_tier_alias_label: 'Tier',
	settings_agent_provider_tier_alias_local: 'Lokal',
	settings_agent_provider_tier_alias_none: 'Kein Tier',
	settings_agent_provider_type_anthropic: 'Anthropic',
	settings_agent_provider_type_grok: 'Grok',
	settings_agent_provider_type_label: 'Provider-Typ',
	settings_agent_provider_type_openai: 'OpenAI',
	settings_agent_provider_type_openai_compatible: 'OpenAI-kompatibel',
	settings_agent_provider_validation_failed: 'Fehler',
	settings_agent_provider_validation_invalid: 'Ungültig',
	settings_agent_provider_validation_unknown: 'Ungeprüft',
	settings_agent_provider_validation_valid: 'Gültig',
	settings_agent_providers_description:
		'Konfigurieren Sie Provider für Agenten. API-Schlüssel werden nicht an die App zurückgegeben.',
	settings_agent_providers_group_title: 'Provider',
	settings_agent_providers_section_description: 'OpenAI, Grok, OpenAI-kompatible Provider und Anthropic verwalten.',
	settings_agent_providers_tab: 'Agent — Provider',
	settings_app_icon: 'App Icon',
	settings_app_icon_description: 'Welches Icon möchten Sie für die App verwenden?',
	settings_app_icon_restore_default: 'Standard wiederherstellen',
	settings_app_icon_section_description: 'App-Symbol für den iOS-Homescreen auswählen und zurücksetzen.',
	settings_behaviour_finished_back_to_list_toggle_caption:
		'Nach dem Erledigen eines Eintrags kehrt die App zur Liste zurück.',
	settings_behaviour_finished_back_to_list_toggle_label: 'Nach dem Erledigen zurück zur Liste springen',
	settings_behaviour_group_workflow: 'Workflow',
	settings_behaviour_section_description: 'Wie die App auf Aktionen reagiert.',
	settings_behaviour_show_split_view_toggle_caption:
		'Geöffnete Einträge erscheinen neben der Liste statt in voller Breite.',
	settings_behaviour_show_split_view_toggle_label: 'Einträge im Seitenpanel öffnen',
	settings_behaviour_splitview_warning_accept: 'Fortfahren',
	settings_behaviour_splitview_warning_message:
		'Beim Umschalten werden alle offenen Detailansichten geschlossen. Ungespeicherte Änderungen gehen verloren.',
	settings_behaviour_splitview_warning_title: 'Seitenpanel umschalten?',
	settings_behaviour_tab: 'Verhalten',
	settings_calendar_appointment_types_active_label: 'Aktiv',
	settings_calendar_appointment_types_add_participant_label: 'Benutzer oder Gruppe hinzufügen',
	settings_calendar_appointment_types_alert_unit_label: 'Alarm Einheit',
	settings_calendar_appointment_types_alert_value_label: 'Alarm Vorlauf',
	settings_calendar_appointment_types_color_label: 'Farbe',
	settings_calendar_appointment_types_delete_cancel_label: 'Abbrechen',
	settings_calendar_appointment_types_delete_confirm_label: 'Löschen',
	settings_calendar_appointment_types_delete_label: 'Löschen',
	settings_calendar_appointment_types_delete_message: 'Soll dieser Termintyp wirklich gelöscht werden?',
	settings_calendar_appointment_types_delete_title: 'Termintyp löschen',
	settings_calendar_appointment_types_description:
		'Termintypen mit Aktivstatus, Globalstatus, Farbe, Teilnehmern, Rechten und Ido-Verknüpfungen verwalten.',
	settings_calendar_appointment_types_description_label: 'Beschreibung',
	settings_calendar_appointment_types_duration_hours_label: 'Dauer Stunden',
	settings_calendar_appointment_types_duration_minutes_label: 'Dauer Minuten',
	settings_calendar_appointment_types_empty_label:
		'Wählen Sie links einen Termintyp aus oder legen Sie einen neuen an.',
	settings_calendar_appointment_types_global_label: 'Global',
	settings_calendar_appointment_types_group_title: 'Termintypen',
	settings_calendar_appointment_types_ido_label: 'Akten',
	settings_calendar_appointment_types_load_error: 'Die Termintypen konnten nicht geladen werden.',
	settings_calendar_appointment_types_new_label: 'Neu',
	settings_calendar_appointment_types_participants_label: 'Teilnehmer und Rechte',
	settings_calendar_appointment_types_remove_participant_label: 'Entfernen',
	settings_calendar_appointment_types_save_label: 'Speichern',
	settings_calendar_appointment_types_section_description:
		'Termintypen, Standardwerte, Rechte und persönliche Farben bearbeiten.',
	settings_calendar_appointment_types_start_hour_label: 'Start Stunde',
	settings_calendar_appointment_types_start_minute_label: 'Start Minute',
	settings_calendar_appointment_types_tab: 'Termintypen',
	settings_calendar_appointment_types_title_label: 'Titel',
	settings_calendar_export_active_appointments_label: 'Aktive Termine',
	settings_calendar_export_add_subscription_label: 'Kalender hinzufügen',
	settings_calendar_export_appointment_type_all_label: 'Alle Termintypen',
	settings_calendar_export_appointment_type_label: 'Termintyp',
	settings_calendar_export_appointment_type_none_label: 'Ohne Termintyp',
	settings_calendar_export_copy_link_error: 'Der iCal-Link konnte nicht in die Zwischenablage kopiert werden.',
	settings_calendar_export_copy_link_label: 'Link kopieren',
	settings_calendar_export_copy_link_success: 'iCal-Link wurde in die Zwischenablage kopiert.',
	settings_calendar_export_description:
		'Fügen Sie den Kalender direkt hinzu, erstellen Sie einen iCal-Link oder laden Sie einen ICS-Export für den ausgewählten Zeitraum herunter.',
	settings_calendar_export_download_label: 'Download',
	settings_calendar_export_end_date_before_start_error: 'Das Enddatum darf nicht vor dem Startdatum liegen.',
	settings_calendar_export_end_date_label: 'Enddatum',
	settings_calendar_export_export_button_label: 'Export starten',
	settings_calendar_export_export_type_ical_label: 'iCal Link',
	settings_calendar_export_export_type_label: 'Exporttyp',
	settings_calendar_export_export_type_webcal_label: 'Kalender-Abo',
	settings_calendar_export_group_result: 'Ergebnis',
	settings_calendar_export_group_title: 'Kalender exportieren',
	settings_calendar_export_ical_link_label: 'iCal Link',
	settings_calendar_export_informative_appointments_label: 'Informative Termine',
	settings_calendar_export_privacy_keep_label: 'Privatsphäre beibehalten',
	settings_calendar_export_privacy_label: 'Datenschutz',
	settings_calendar_export_privacy_public_label: 'Alle auf öffentlich setzen',
	settings_calendar_export_result_hint:
		'Der Link kann in externen Kalendern als abonnierbarer Kalender verwendet werden.',
	settings_calendar_export_section_description: 'Kalender als ICS-Datei exportieren oder iCal-Link erzeugen.',
	settings_calendar_export_start_date_error: 'Bitte wählen Sie ein Startdatum aus.',
	settings_calendar_export_start_date_label: 'Startdatum',
	settings_calendar_export_tab: 'Export',
	settings_calendar_export_unavailable_error: 'Kalender-Export ist aktuell nicht verfügbar.',
	settings_calendar_general_description:
		'Startansicht und sichtbare Ansichten werden nur für die in der App wirksamen Kalender-Views gespeichert.',
	settings_calendar_general_group_title: 'Kalenderansicht',
	settings_calendar_general_section_description: 'Startansicht und sichtbare Kalenderansichten der App festlegen.',
	settings_calendar_general_start_view_label: 'Startansicht',
	settings_calendar_general_tab: 'Ansicht',
	settings_calendar_general_visible_views_label: 'Sichtbare Ansichten',
	settings_calendar_settings_save_error: 'Die Kalendereinstellung konnte nicht gespeichert werden.',
	settings_calendar_sharing_allow_toggle_label: 'Einsicht erlauben',
	settings_calendar_sharing_allowed_caption: 'Dieser Benutzer darf Ihren Kalender einsehen.',
	settings_calendar_sharing_blocked_caption: 'Dieser Benutzer ist für die Kalendereinsicht gesperrt.',
	settings_calendar_sharing_description:
		'Steuern Sie, welche Benutzer Ihren Kalender einsehen dürfen. Änderungen werden sofort gespeichert.',
	settings_calendar_sharing_group_title: 'Freigaben',
	settings_calendar_sharing_loading_label: 'Kalenderfreigaben werden geladen...',
	settings_calendar_sharing_section_description: 'Einsichtsrechte für den eigenen Kalender verwalten.',
	settings_calendar_sharing_tab: 'Freigaben',
	settings_category_account_description: 'Profil, Instanzen, Profilbild und Zeitzone.',
	settings_category_account_label: 'Konto',
	settings_category_advanced_description: 'Benutzergruppen, Präsenz und Dashboard.',
	settings_category_advanced_label: 'Erweitert',
	settings_category_agent_description: 'Provider, Memory und Agent-Konfiguration.',
	settings_category_agent_label: 'Agent',
	settings_category_appearance_description: 'Theme, Farben und visuelle Sprache der App.',
	settings_category_appearance_label: 'Erscheinungsbild',
	settings_category_calendar_description: 'Kalenderansicht, Termintypen, Freigaben und Export.',
	settings_category_calendar_label: 'Kalender',
	settings_category_general_description: 'Benutzer, Benachrichtigungen, Orte und Darstellung.',
	settings_category_general_label: 'Allgemein',
	settings_category_mail_description: 'E-Mail-Regeln, Filter und automatische Weiterleitungen.',
	settings_category_mail_label: 'Mail',
	settings_category_notifications_description: 'Push, Hinweise und Benachrichtigungswege steuern.',
	settings_category_notifications_label: 'Benachrichtigungen',
	settings_category_phone_description: 'Wählhilfe und Anruflisten konfigurieren.',
	settings_category_phone_label: 'Telefon',
	settings_category_shortcuts_description: 'Tastenkombinationen für Navigation, Aktionen und Editor.',
	settings_category_shortcuts_label: 'Tastenkürzel',
	settings_category_support_description: 'Hilfe, Orientierung und Produktinformationen.',
	settings_category_support_label: 'Hilfe & Info',
	settings_category_workspace_description: 'Layout, Menüs, Listen, Widgets und Verhalten.',
	settings_category_workspace_label: 'Arbeitsbereich',
	settings_common_avatar_delete_dialog_confirm_cancel_label: 'Nein',
	settings_common_avatar_delete_dialog_confirm_message: 'Möchten Sie das Profilbild wirklich löschen?',
	settings_common_avatar_delete_dialog_confirm_ok_label: 'Ja',
	settings_common_avatar_delete_dialog_confirm_title: 'Profilbild löschen?',
	settings_common_avatar_description: 'Profilbild für die ausgewählte Instanz',
	settings_common_change_password_button_label: 'Passwort ändern',
	settings_common_change_password_cancel_label: 'Abbrechen',
	settings_common_change_password_confirmation_label: 'Neues Passwort wiederholen',
	settings_common_change_password_current_label: 'Aktuelles Passwort',
	settings_common_change_password_dialog_title: 'Passwort ändern',
	settings_common_change_password_error_confirmation_mismatch:
		'Die Wiederholung stimmt nicht mit dem neuen Passwort überein.',
	settings_common_change_password_error_current_required: 'Bitte geben Sie Ihr aktuelles Passwort ein.',
	settings_common_change_password_error_new_too_long:
		'Das neue Passwort darf höchstens {maxLength} Zeichen lang sein.',
	settings_common_change_password_error_new_too_short:
		'Das neue Passwort muss mindestens {minLength} Zeichen lang sein.',
	settings_common_change_password_error_request_failed:
		'Das Passwort konnte nicht geändert werden. Bitte versuchen Sie es erneut.',
	settings_common_change_password_error_wrong_current: 'Das aktuelle Passwort ist falsch.',
	settings_common_change_password_new_label: 'Neues Passwort',
	settings_common_change_password_submit_label: 'Passwort speichern',
	settings_common_change_password_success: 'Ihr Passwort wurde geändert.',
	settings_common_configured_instances_description: 'Ihre konfigurierten Instanzen',
	settings_common_delete_avatar_button_label: 'Profilbild löschen',
	settings_common_group_account_actions: 'Konto-Aktionen',
	settings_common_group_instances: 'Instanzen',
	settings_common_group_language_region: 'Sprache & Region',
	settings_common_group_profile: 'Profil',
	settings_common_instance_active_label: 'Aktiv',
	settings_common_instance_description: 'Möchten Sie weitere Instanzen hinzufügen oder Ihr Profilbild austauschen?',
	settings_common_profile_loading: 'Profil wird geladen...',
	settings_common_section_description: 'Profil, Instanzen, Profilbild und grundlegende Kontoeinstellungen.',
	settings_common_tab: 'Benutzer',
	settings_common_update_avatar_button_label: 'Profilbild austauschen',
	settings_common_update_avatar_dialog_camera: 'Mit der Kamera erstellen',
	settings_common_update_avatar_dialog_cancel: 'Abbrechen',
	settings_common_update_avatar_dialog_create_new_avatar: 'Profilbild austauschen',
	settings_common_update_avatar_dialog_create_new_avatar_source: 'Hier können Sie ein neues Profilbild wählen',
	settings_common_update_avatar_dialog_mediathek: 'Aus Fotomediathek auswählen',
	settings_common_update_avatar_dialog_select_files: 'Aus Dateisystem auswählen',
	settings_common_update_avatar_dialog_selected_files: 'Ausgewählte Datei',
	settings_common_update_avatar_dialog_upload_error: 'Das Profilbild konnte nicht hochgeladen werden.',
	settings_common_update_avatar_dialog_upload_files: 'Profilbild hochladen',
	settings_common_update_avatar_dialog_uploading: 'Lade hoch …',
	settings_controls: 'Steuerung Listenelemente',
	settings_controls_context_menu: 'Kontextmenü',
	settings_controls_swipe_menu: 'Wischen',
	settings_controls_tab: 'Steuerung in Listen',
	settings_daily_activity_section_description: 'Aktivitäten des gewählten Tages einsehen.',
	settings_daily_activity_tab: 'Tagesaktionen',
	settings_dashboard_diagnosis_alarm_center_text: 'Das Alarm-Center ist aktuell nicht aktiv.',
	settings_dashboard_diagnosis_alarm_center_title: 'Alarm-Center deaktiviert',
	settings_dashboard_diagnosis_empty_text: 'Es liegen derzeit keine Diagnoseinformationen vor.',
	settings_dashboard_diagnosis_mailparser_text: 'Der Mailparser meldet Probleme bei der Verarbeitung.',
	settings_dashboard_diagnosis_mailparser_title: 'Mailparser-Problem',
	settings_dashboard_diagnosis_no_details: 'Keine weiteren Details vorhanden.',
	settings_dashboard_diagnosis_signature_text: 'Mindestens ein Postfach besitzt keine Standardsignatur.',
	settings_dashboard_diagnosis_signature_title: 'Standardsignaturen fehlen',
	settings_dashboard_diagnosis_standard_postbox_text: 'Es ist kein Standard-Postfach gesetzt.',
	settings_dashboard_diagnosis_standard_postbox_title: 'Standard-Postfach fehlt',
	settings_dashboard_diagnosis_success_text:
		'Die wichtigsten Legacy-Prüfungen sind aktuell ohne auffällige Warnungen.',
	settings_dashboard_diagnosis_success_title: 'Keine offenen Diagnosewarnungen',
	settings_dashboard_diagnosis_title: 'Diagnose & Hinweise',
	settings_dashboard_diagnosis_too_many_text: 'Auf dem Welcome-Bereich liegen zu viele Elemente.',
	settings_dashboard_diagnosis_too_many_title: 'Zu viele Elemente',
	settings_dashboard_empty_text: 'Sobald Daten vorliegen oder geladen werden können, erscheinen sie hier.',
	settings_dashboard_empty_title: 'Noch keine Daten',
	settings_dashboard_eyebrow: 'Legacy Dashboard',
	settings_dashboard_metric_active_users: 'Aktive Benutzer',
	settings_dashboard_metric_inactive_users: 'Inaktive Benutzer',
	settings_dashboard_metric_incoming_mails: 'Eingehende Mails',
	settings_dashboard_metric_outgoing_mails: 'Ausgehende Mails',
	settings_dashboard_metric_red_calls: 'Rote Anrufe',
	settings_dashboard_metric_red_mails: 'Rote Mails',
	settings_dashboard_metric_virtual_users: 'Virtuelle Benutzer',
	settings_dashboard_module_activity: 'Aktivitäten',
	settings_dashboard_module_calls: 'Anrufe',
	settings_dashboard_module_documents: 'Dokumente',
	settings_dashboard_module_emails: 'E-Mails',
	settings_dashboard_module_messages: 'Nachrichten',
	settings_dashboard_module_notes: 'Merkzettel',
	settings_dashboard_module_tasks: 'Aufgaben',
	settings_dashboard_module_totals: 'Gesamt',
	settings_dashboard_moment_empty_text: 'Für die aktuelle Aktivitätsverteilung sind noch keine Werte vorhanden.',
	settings_dashboard_moment_title: 'Aktuelle Verteilung',
	settings_dashboard_overview_description:
		'Eine moderne, responsive Übersicht der Legacy-Dashboard-Statistiken für Aktivität, Systemstatus und Hinweise.',
	settings_dashboard_overview_title: 'Dashboard für Arbeitsbereich und Systemgesundheit',
	settings_dashboard_partial_error_title: 'Einige Dashboard-Bereiche konnten nicht geladen werden.',
	settings_dashboard_performance_empty_text: 'Aktuell liegt kein Performance-Ranking vor.',
	settings_dashboard_performance_title: 'Performance-Ranking',
	settings_dashboard_period_empty_text: 'Für den Aktivitätsverlauf der letzten Tage liegen noch keine Werte vor.',
	settings_dashboard_period_title: 'Verlauf der letzten Tage',
	settings_dashboard_refresh: 'Aktualisieren',
	settings_dashboard_section_description:
		'Statistiken, Diagnosehinweise und Systemkennzahlen aus dem Legacy-Dashboard einsehen.',
	settings_dashboard_system_forbidden_text: 'Die Systemkennzahlen sind nur für berechtigte Benutzer sichtbar.',
	settings_dashboard_system_forbidden_title: 'Systeminformationen gesperrt',
	settings_dashboard_system_title: 'Systeminformationen',
	settings_dashboard_tab: 'Dashboard',
	settings_dateformat_caption: 'Wie Datumsangaben in der App angezeigt werden',
	settings_dateformat_label: 'Datumsformat',
	settings_group_active: 'Aktiv',
	settings_group_create: 'Erstellen',
	settings_group_delete: 'Löschen',
	settings_group_description: 'Hier können Sie Benutzergruppen erstellen und bearbeiten!',
	settings_group_empty_hint: 'Bitte eine Gruppe auswählen',
	settings_group_globalRight_activated: 'Freigegebene Gruppe von %name%',
	settings_group_globalRight_deactivated: 'Gruppe allen Benutzern freigeben',
	settings_group_members: 'Gruppenmitglieder',
	settings_group_members_empty: 'Fügen Sie Mitglieder aus der rechten Liste hinzu',
	settings_group_name: 'Name:',
	settings_group_save: 'Speichern',
	settings_group_settings: 'Einstellungen',
	settings_group_tab: 'Gruppe',
	settings_group_unassigned: 'Unzugewiesene Benutzer',
	settings_group_unassigned_empty: 'Alle Benutzer sind dieser Gruppe zugewiesen',
	settings_groups_section_description: 'Benutzergruppen verwalten und Zuständigkeiten strukturieren.',
	settings_groups_tab: 'Benutzergruppen',
	settings_help_section_description: 'Hilfethemen und Unterstützung schnell erreichen.',
	settings_help_tab: 'Hilfe',
	settings_language_caption: 'Sprache der App – Deutsch, Englisch oder der Systemeinstellung folgen',
	settings_language_label: 'Sprache',
	settings_language_option_system: 'Systemsprache folgen',
	settings_layout_bottom_left_main_toolbar_slot_label: 'Unten links',
	settings_layout_bottom_right_main_toolbar_slot_label: 'Unten rechts',
	settings_layout_configurable_layout_slot_buttons_avatar_description:
		'Das Profilbild des eigenen Benutzers und Instanzauswahl',
	settings_layout_configurable_layout_slot_buttons_avatar_label: 'Profilbild',
	settings_layout_configurable_layout_slot_buttons_contact_information_description: 'Öffnet die Kontaktdatensuche',
	settings_layout_configurable_layout_slot_buttons_contact_information_label: 'Kontaktieren',
	settings_layout_configurable_layout_slot_buttons_create_description: 'Menü zum erstellen neuer Aktivitäten',
	settings_layout_configurable_layout_slot_buttons_create_label: 'Neu',
	settings_layout_configurable_layout_slot_buttons_idos_description: 'Übersicht der Akteninstanzen',
	settings_layout_configurable_layout_slot_buttons_idos_label: 'Akten',
	settings_layout_configurable_layout_slot_buttons_loading_indicator_description:
		'Ein Indikator der das aktuelle Modul und Ladeaktivität anzeigt',
	settings_layout_configurable_layout_slot_buttons_loading_indicator_label: 'Indikator',
	settings_layout_configurable_layout_slot_buttons_menu_description: 'Das Menü zur Navigation zwischen den Module',
	settings_layout_configurable_layout_slot_buttons_menu_label: 'Menü',
	settings_layout_configurable_layout_slot_buttons_none_description: 'Dieser Slot soll nicht benutzt werden',
	settings_layout_configurable_layout_slot_buttons_none_label: 'Slot nicht benutzen',
	settings_layout_configurable_layout_slot_buttons_search_description: 'Öffnet den Suchen Dialog',
	settings_layout_configurable_layout_slot_buttons_search_label: 'Suche',
	settings_layout_configurable_layout_slot_buttons_settings_description: 'Das Einstellungsmodul',
	settings_layout_configurable_layout_slot_buttons_settings_label: 'Einstellungen',
	settings_layout_configurable_layout_slot_buttons_timer_description: 'Öffnet Ihre Timer Übersicht',
	settings_layout_configurable_layout_slot_buttons_timer_label: 'Timer',
	settings_layout_configurable_layout_slot_buttons_user_online_description: 'Die Benutzeronline Liste',
	settings_layout_configurable_layout_slot_buttons_user_online_label: 'Benutzer online',
	settings_layout_description: 'An welcher Position soll die Liste der angemeldeten Benutzer angezeigt werden?',
	settings_layout_description_small_device:
		'Welche Elemente sollten sich in der oberen Leiste und in dem Menü unten befinden?',
	settings_layout_group_mobile_bottom_bar: 'Untere Leiste',
	settings_layout_group_mobile_top_bar: 'Obere Leiste',
	settings_layout_group_modules: 'Module',
	settings_layout_group_navigation: 'Navigation',
	settings_layout_group_user_list: 'Benutzerliste',
	settings_layout_group_work_mode: 'Arbeitsmodus',
	settings_layout_mobile_section_description: 'Mobile Toolbar-Slots und Smartphone-Bedienung konfigurieren.',
	settings_layout_navigation_mode_caption:
		'Wähle ob die Navigation als Sidebar oder als Top-Bar im Header angezeigt wird',
	settings_layout_navigation_mode_label: 'Navigationsmodus',
	settings_layout_navigation_mode_sidebar: 'Sidebar',
	settings_layout_navigation_mode_topbar: 'Top-Bar',
	settings_layout_section_description: 'Desktop-Layout, Drawer und Sichtbarkeit im Arbeitsbereich steuern.',
	settings_layout_tab: 'Layout',
	settings_layout_timer_enabled_caption: 'Blendet den Timer im Header und in Menüs ein oder aus',
	settings_layout_timer_enabled_label: 'Timer aktivieren',
	settings_layout_top_left_main_toolbar_slot_first_label: 'Oben links 1',
	settings_layout_top_left_main_toolbar_slot_second_label: 'Oben links 2',
	settings_layout_top_right_main_toolbar_slot_first_label: 'Oben rechts 1',
	settings_layout_top_right_main_toolbar_slot_second_label: 'Oben rechts 2',
	settings_layout_user_online_position_label: 'Position der Benutzerliste',
	settings_layout_user_online_position_left: 'Links',
	settings_layout_user_online_position_off: 'Aus',

	settings_layout_user_online_position_right: 'Rechts',
	settings_layout_user_show_offline_users: 'Auch abgemeldete Benutzer anzeigen',

	settings_list_avatar_toggle_infobar_module: 'Infobar Modul',
	settings_list_avatar_toggle_label: 'Profilbild',
	settings_list_avatar_toggle_mode_avatar: 'Profilbild Person',
	settings_list_avatar_toggle_mode_module: 'Profilbild Modul',
	settings_list_grouping_toggle_mode_module: 'Modul',
	settings_list_grouping_toggle_mode_none: 'Keine Gruppierung',
	settings_list_grouping_toggle_mode_timeframe: 'Zeitfenster',
	settings_list_preview_linked_idos: 'Verknüpfte Akten',
	settings_list_preview_title: 'Titel',
	settings_lists_column_apply_all: 'Für alle Module übernehmen',
	settings_lists_column_apply_all_confirm_message: 'Spaltenkonfiguration von „{module}“ auf alle Module übertragen?',
	settings_lists_column_apply_all_success: 'Spaltenkonfiguration für alle Module übernommen',

	settings_lists_column_header_drag_hint:
		'Tipp: Die Reihenfolge lässt sich auch direkt in der Liste per Ziehen der Spaltenüberschriften ändern.',
	settings_lists_column_hidden_heading: 'Ausgeblendet',

	settings_lists_column_modified_indicator: 'Angepasst',
	settings_lists_column_module_label: 'Modul',

	settings_lists_column_order_hint: 'Oben = links in der Liste',

	settings_lists_column_preview_label: 'Vorschau – so sieht die Liste aus',

	settings_lists_column_reset: 'Zurücksetzen',

	settings_lists_column_reset_success: 'Spaltenkonfiguration von „{module}“ zurückgesetzt',
	settings_lists_column_shown_heading: 'Angezeigte Spalten',
	settings_lists_description: 'Wie soll eine Zeile in den Modulen dargestellt werden?',
	settings_lists_extended: 'Erweitert',
	settings_lists_group_column_order: 'Spaltenreihenfolge',
	settings_lists_group_grouping: 'Gruppierung',
	settings_lists_group_preview: 'Vorschau',
	settings_lists_grouping_description: 'Wie sollen die Zeilen der Inbox gruppiert werden?',
	settings_lists_module_record_history: 'Akten-Historie',
	settings_lists_preview_description: 'Vorschau',
	settings_lists_section_description: 'Listenansicht, Vorschau und Gruppierung festlegen.',
	settings_lists_tab: 'Listen',
	settings_logout_button_label: 'Abmelden',
	settings_mail_auto_delegate_section_description:
		'Automatische Delegationsregeln für eingehende Mails konfigurieren.',
	settings_mail_auto_delegate_tab: 'Auto-Delegation',

	settings_mail_blacklist_section_description: 'Absender dauerhaft blockieren und Blacklist verwalten.',

	settings_mail_blacklist_tab: 'Blacklist',
	settings_mail_no_archive_section_description: 'Adressen festlegen, die ausgeblendet werden sollen.',

	settings_mail_no_archive_tab: 'Ausgeblendete Adressen',
	settings_mail_remove_spam_section_description: 'Regeln definieren, um die Spammarkierung automatisch zu entfernen.',
	settings_mail_remove_spam_tab: 'Spammarkierung entfernen',
	settings_mail_signatures_section_description:
		'Persönliche Signaturen, Platzhalterdaten und globale Signaturen verwalten.',
	settings_mail_signatures_tab: 'Signaturen',
	settings_mail_spam_section_description: 'Spam-Erkennungsregeln erstellen und verwalten.',

	settings_mail_spam_tab: 'Spam-Regeln',
	settings_menu_description: 'In welcher Reihenfolge möchten Sie Ihre Menüpunkte anzeigen?',
	settings_menu_group_order: 'Reihenfolge',

	settings_menu_inverse_caption:
		'Das Menü der unteren Leiste klappt nach oben auf - umgekehrt sortiert liegen die ersten Einträge direkt über dem Daumen.',
	settings_menu_inverse_label: 'Menü der unteren Leiste umgekehrt sortieren',

	settings_menu_section_description: 'Menüreihenfolge und Navigation anpassen.',
	settings_menu_tab: 'Menü',

	settings_mobile_recents_label: 'Zuletzt verwendet',
	settings_navigation_title: 'Einstellungen',
	settings_new_theme_label: 'Neues Theme',
	settings_notifications_appointment: 'Termine',
	settings_notifications_description: 'Für welche Aktivitäten möchten Sie Push-Benachrichtigungen erhalten?',
	settings_notifications_documents: 'Dokumente',
	settings_notifications_group_calendar: 'Kalender',
	settings_notifications_group_email: 'E-Mail',
	settings_notifications_group_push: 'Push',
	settings_notifications_ido: 'Akten',
	settings_notifications_ido_subscriptions_add: 'Hinzufügen',
	settings_notifications_ido_subscriptions_all_instances: 'Alle meine Instanzen',
	settings_notifications_ido_subscriptions_any_user: 'Jeder Bearbeiter',
	settings_notifications_ido_subscriptions_caption:
		'Legen Sie fest, für welche Instanzen und welchen Bearbeiter Sie benachrichtigt werden, wenn eine Akte gespeichert wird.',
	settings_notifications_ido_subscriptions_empty: 'Noch keine Akten-Benachrichtigungen eingerichtet.',
	settings_notifications_ido_subscriptions_instance_placeholder: 'Instanz wählen',
	settings_notifications_ido_subscriptions_remove: 'Entfernen',
	settings_notifications_ido_subscriptions_user_placeholder: 'Bearbeiter wählen',

	settings_notifications_load_error_retry: 'Erneut versuchen',
	settings_notifications_load_error_text:
		'Die Benachrichtigungseinstellungen sind gerade nicht erreichbar. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
	settings_notifications_load_error_title: 'Benachrichtigungen konnten nicht geladen werden',
	settings_notifications_mail: 'Mails',
	settings_notifications_message: 'Nachrichten',
	settings_notifications_modules_group: 'Module',
	settings_notifications_notes: 'Merkzettel',
	settings_notifications_phone_calls: 'Anrufe',
	settings_notifications_section_description: 'Push-Benachrichtigungen für Module und Aktivitäten verwalten.',
	settings_notifications_tab: 'Benachrichtigungen',
	settings_notifications_tasks: 'Aufgaben',
	settings_page_subtitle:
		'Kategorien, Schlagworte und schnelle Sprünge helfen Ihnen dabei, auch auf kleineren Displays sofort zur richtigen Einstellung zu kommen.',
	settings_page_title: 'Einstellungen auf einen Blick',
	settings_performance_caching_toggle_label: 'Performance Caching',
	settings_personal_access_tokens_acquisition_manual_pat: 'Manueller Token',
	settings_personal_access_tokens_acquisition_oauth: 'Verbundene App',
	settings_personal_access_tokens_admin_column_revocation_reason: 'Begründung',
	settings_personal_access_tokens_admin_column_revoked_by: 'Widerrufen von',
	settings_personal_access_tokens_admin_column_user: 'Benutzer',
	settings_personal_access_tokens_admin_empty: 'Es sind keine administrierbaren Zugriffe vorhanden.',
	settings_personal_access_tokens_admin_loading: 'Alle Zugangstoken werden geladen...',
	settings_personal_access_tokens_admin_section_description:
		'Persönliche Zugangstoken anderer Benutzer auf dieser Instanz prüfen und widerrufen.',
	settings_personal_access_tokens_admin_section_title: 'Alle persönlichen Zugangstoken',
	settings_personal_access_tokens_column_acquisition_type: 'Zugriffsart',
	settings_personal_access_tokens_column_actions: 'Aktionen',
	settings_personal_access_tokens_column_created_at: 'Erstellt',
	settings_personal_access_tokens_column_expires_at: 'Läuft ab',
	settings_personal_access_tokens_column_last_used_at: 'Zuletzt verwendet',
	settings_personal_access_tokens_column_name: 'Name',
	settings_personal_access_tokens_column_scopes: 'Berechtigungen',
	settings_personal_access_tokens_column_status: 'Status',
	settings_personal_access_tokens_connect_button: 'App verbinden',
	settings_personal_access_tokens_connect_codex_guidance:
		'Fügen Sie diese MCP-Adresse in Ihrem OAuth-fähigen MCP-Client hinzu und starten Sie dort die Verbindung. Anmeldung und Freigabe der Berechtigungen erfolgen anschließend in der infra-struktur-app.',
	settings_personal_access_tokens_connect_copy_button: 'Ressource kopieren',
	settings_personal_access_tokens_connect_copy_error: 'Die MCP-Ressource konnte nicht kopiert werden.',
	settings_personal_access_tokens_connect_copy_success: 'Die MCP-Ressource wurde kopiert.',
	settings_personal_access_tokens_connect_dialog_title: 'App verbinden',
	settings_personal_access_tokens_connect_resource: 'MCP-Ressource',
	settings_personal_access_tokens_create_alias_custom_label: 'Eigene Auswahl',
	settings_personal_access_tokens_create_alias_read_only_hint: 'Alle Lesezugriffe für die unterstützten Module.',
	settings_personal_access_tokens_create_alias_read_only_label: 'Nur lesen',
	settings_personal_access_tokens_create_alias_read_write_hint:
		'Alle Lese- und Schreibzugriffe für die unterstützten Module. Enthält löschende Aktionen.',
	settings_personal_access_tokens_create_alias_read_write_label: 'Lesen und schreiben',
	settings_personal_access_tokens_create_button: 'Neuer Token',
	settings_personal_access_tokens_create_cancel_label: 'Abbrechen',
	settings_personal_access_tokens_create_capability_agent_execute: 'Agent-Aktionen ausführen',
	settings_personal_access_tokens_create_capability_alarm_read: 'Erinnerungen lesen',
	settings_personal_access_tokens_create_capability_calendar_read: 'Termine lesen',
	settings_personal_access_tokens_create_capability_contact_read: 'Kontakte lesen',
	settings_personal_access_tokens_create_capability_desktop_read: 'Startseite lesen',
	settings_personal_access_tokens_create_capability_document_read: 'Dokumentenablage lesen',
	settings_personal_access_tokens_create_capability_ido_activity_read: 'Aktivitäten lesen',
	settings_personal_access_tokens_create_capability_ido_activity_write: 'Aktivitäten schreiben',
	settings_personal_access_tokens_create_capability_ido_document_read: 'Dokumente lesen',
	settings_personal_access_tokens_create_capability_ido_document_write: 'Dokumente schreiben',
	settings_personal_access_tokens_create_capability_ido_print_execute: 'Druckaktionen ausführen',
	settings_personal_access_tokens_create_capability_ido_print_read: 'Druckkonfigurationen lesen',
	settings_personal_access_tokens_create_capability_ido_read: 'Akten lesen',
	settings_personal_access_tokens_create_capability_ido_write: 'Akten schreiben',
	settings_personal_access_tokens_create_capability_kanban_read: 'Kanban-Boards lesen',
	settings_personal_access_tokens_create_capability_kanban_write: 'Kanban-Boards schreiben',
	settings_personal_access_tokens_create_capability_mail_read: 'E-Mails lesen',
	settings_personal_access_tokens_create_capability_mail_rules_read: 'Mail-Regeln lesen',
	settings_personal_access_tokens_create_capability_mail_signature_read: 'Mail-Signaturen lesen',
	settings_personal_access_tokens_create_capability_message_read: 'Nachrichten lesen',
	settings_personal_access_tokens_create_capability_my_settings_read: 'Eigene Einstellungen lesen',
	settings_personal_access_tokens_create_capability_note_read: 'Merkzettel lesen',
	settings_personal_access_tokens_create_capability_notification_read: 'Benachrichtigungen lesen',
	settings_personal_access_tokens_create_capability_phonecall_read: 'Anrufe lesen',
	settings_personal_access_tokens_create_capability_task_read: 'Aufgaben lesen',
	settings_personal_access_tokens_create_capability_user_preferences_read: 'Benutzereinstellungen lesen',
	settings_personal_access_tokens_create_capability_user_read_self: 'Eigenen Benutzer lesen',
	settings_personal_access_tokens_create_capability_user_state_read: 'Benutzerstatus lesen',
	settings_personal_access_tokens_create_clipboard_error_message:
		'Der Token konnte nicht in die Zwischenablage kopiert werden.',
	settings_personal_access_tokens_create_clipboard_success_message: 'Der Token wurde in die Zwischenablage kopiert.',
	settings_personal_access_tokens_create_dialog_title: 'Persönlichen Zugangstoken erstellen',
	settings_personal_access_tokens_create_field_expires_at_hint:
		'Optional. Wählen Sie ein zukünftiges Datum, um die Gültigkeit zu begrenzen.',
	settings_personal_access_tokens_create_field_expires_at_label: 'Läuft ab am',
	settings_personal_access_tokens_create_field_name_hint:
		'Eine kurze Beschreibung, an der Sie den Token wiedererkennen.',
	settings_personal_access_tokens_create_field_name_label: 'Bezeichnung',
	settings_personal_access_tokens_create_field_scopes_hint:
		'Wählen Sie eine Voreinstellung oder die genauen Berechtigungen, die der Token erhalten soll.',
	settings_personal_access_tokens_create_field_scopes_label: 'Berechtigungen',
	settings_personal_access_tokens_create_submit_label: 'Token erstellen',
	settings_personal_access_tokens_create_success_acknowledge_button: 'Ich habe den Token gespeichert',
	settings_personal_access_tokens_create_success_copy_button: 'Token kopieren',
	settings_personal_access_tokens_create_success_title: 'Ihr neuer Token',
	settings_personal_access_tokens_create_success_warning_message:
		'Dieser Token wird nur einmal angezeigt. Speichern Sie ihn an einem sicheren Ort, bevor Sie diesen Dialog schließen.',
	settings_personal_access_tokens_details_button: 'Details',
	settings_personal_access_tokens_details_client: 'OAuth-Client',
	settings_personal_access_tokens_details_dialog_title: 'Zugriffsdetails',
	settings_personal_access_tokens_details_revoked_at: 'Widerrufen am',
	settings_personal_access_tokens_edit_scopes_button: 'Berechtigungen bearbeiten',
	settings_personal_access_tokens_edit_scopes_cancel_label: 'Abbrechen',
	settings_personal_access_tokens_edit_scopes_dialog_title: 'Berechtigungen bearbeiten',
	settings_personal_access_tokens_edit_scopes_submit_label: 'Berechtigungen speichern',
	settings_personal_access_tokens_edit_scopes_success_message: 'Berechtigungen wurden aktualisiert.',
	settings_personal_access_tokens_empty_hint:
		'Erstellen Sie einen persönlichen Zugangstoken, um externen Werkzeugen einen begrenzten Zugriff zu erlauben.',
	settings_personal_access_tokens_empty_title: 'Noch keine persönlichen Zugangstoken vorhanden',
	settings_personal_access_tokens_error_oauth_reconnect_required:
		'OAuth-Berechtigungen können nur durch eine neue Verbindung geändert werden.',
	settings_personal_access_tokens_loading: 'Zugangstoken werden geladen...',
	settings_personal_access_tokens_loading_error: 'Die persönlichen Zugangstoken konnten nicht geladen werden.',
	settings_personal_access_tokens_manual_create_button: 'Token manuell erstellen',
	settings_personal_access_tokens_reconnect_button: 'Neu verbinden',
	settings_personal_access_tokens_reconnect_dialog_intro:
		'Verbinden Sie diese App erneut, um ihre Autorisierung zu erneuern und die angeforderten Berechtigungen zu bestätigen.',
	settings_personal_access_tokens_reconnect_dialog_title: 'App neu verbinden',
	settings_personal_access_tokens_retry_button: 'Erneut versuchen',
	settings_personal_access_tokens_revoke_cancel_label: 'Abbrechen',
	settings_personal_access_tokens_revoke_dialog_message:
		'Mit dem Widerruf wird dieser Zugriff sofort für weitere Anfragen gesperrt. Diese Aktion kann nicht rückgängig gemacht werden.',
	settings_personal_access_tokens_revoke_dialog_title: 'Zugriff widerrufen',
	settings_personal_access_tokens_revoke_field_reason_hint:
		'Optional. Die Begründung wird Administratoren im Audit-Log angezeigt.',
	settings_personal_access_tokens_revoke_field_reason_label: 'Begründung',
	settings_personal_access_tokens_revoke_submit_label: 'Widerrufen',
	settings_personal_access_tokens_revoke_success_message: 'Zugriff wurde widerrufen.',
	settings_personal_access_tokens_save_error: 'Der persönliche Zugangstoken konnte nicht gespeichert werden.',
	settings_personal_access_tokens_scope_unknown: 'Unbekannte Berechtigung',
	settings_personal_access_tokens_search_terms: 'oauth,codex,verbinden,manueller token,mcp,api',
	settings_personal_access_tokens_section_description:
		'Apps verbinden oder manuell erstellte Token für begrenzte Zugriffe auf diese Instanz verwalten.',
	settings_personal_access_tokens_section_title: 'MCP-/API-Zugriff',
	settings_personal_access_tokens_status_active: 'Aktiv',
	settings_personal_access_tokens_status_expired: 'Abgelaufen',
	settings_personal_access_tokens_status_reauthorization_required: 'Neue Verbindung erforderlich',
	settings_personal_access_tokens_status_revoked: 'Widerrufen',
	settings_personal_access_tokens_value_unavailable: 'Nicht verfügbar',
	settings_phone_calllist_name_header: 'Name',
	settings_phone_calllist_standard_header: 'Standard',
	settings_phone_direct_dial_label: 'Durchwahl',
	settings_phone_group_calllists: 'Anruflisten',
	settings_phone_group_dial_help: 'Wählhilfe',
	settings_phone_location_label: 'Standort',
	settings_phone_save_button: 'Speichern',
	settings_phone_section_description: 'Wählhilfe und Anruflisten konfigurieren.',
	settings_phone_tab: 'Telefon',
	settings_publish_toggle_label: 'Öffentlich',
	settings_search_empty_hint: 'Versuchen Sie Begriffe wie Profilbild, Push, Layout, Kalender oder Menü.',
	settings_search_empty_title: 'Keine passende Einstellung gefunden',
	settings_search_placeholder: 'Suchen',
	settings_search_results: 'Direkte Treffer',
	settings_search_tags_label: 'Suchbegriffe',
	settings_share_toggle_label: 'Teilen',
	settings_shortcuts_section_description: 'Tastenkombinationen für Navigation, Aktionen und Editor anpassen.',
	settings_shortcuts_tab: 'Tastenkürzel',
	settings_start_page_alias_placeholder: 'Alias',
	settings_start_page_alias_search_empty: 'Keine Kanäle gefunden.',
	settings_start_page_alias_search_placeholder: 'Kanäle durchsuchen…',
	settings_start_page_aliases_group_description:
		'Eigener Anzeigename für den jeweiligen Kanal. Leer lassen, um den Originalnamen zu verwenden.',
	settings_start_page_aliases_group_title: 'Kanal-Aliase',
	settings_start_page_channel_tab_document: 'Dokumente',
	settings_start_page_channel_tab_email: 'E-Mails',
	settings_start_page_channel_tab_phonecall: 'Anrufe',
	settings_start_page_channels_empty: 'Keine Kanäle verfügbar.',
	settings_start_page_channels_group_description:
		'Nur Einträge aus aktivierten Kanälen erscheinen auf der Startseite.',
	settings_start_page_channels_group_title: 'Kanal-Abonnements',
	settings_start_page_load_error: 'Konnte nicht geladen werden.',
	settings_start_page_loading: 'Wird geladen…',
	settings_start_page_module_activity: 'Aktennotizen',
	settings_start_page_module_activity_caption: 'Fällige Aktennotizen und Wiedervorlagen aus Akten.',
	settings_start_page_module_appointment: 'Termine heute',
	settings_start_page_module_appointment_caption: 'Die Termine des heutigen Tages.',
	settings_start_page_module_document: 'Dokumente',
	settings_start_page_module_document_caption: 'Noch nicht erledigte Dokumente aus den abonnierten Ablagen.',
	settings_start_page_module_email: 'E-Mails',
	settings_start_page_module_email_caption: 'Noch nicht erledigte E-Mails aus den abonnierten Postfächern.',
	settings_start_page_module_message: 'Nachrichten',
	settings_start_page_module_message_caption: 'Noch nicht erledigte interne Nachrichten.',
	settings_start_page_module_note: 'Merkzettel',
	settings_start_page_module_note_caption: 'Persönliche Merkzettel.',
	settings_start_page_module_phonecall: 'Anrufe',
	settings_start_page_module_phonecall_caption: 'Noch nicht erledigte Anrufeinträge aus den Anruflisten.',
	settings_start_page_module_task: 'Aufgaben',
	settings_start_page_module_task_caption: 'Noch nicht erledigte Aufgaben.',
	settings_start_page_modules_group_description:
		'Legt fest, welche Bereiche in der Startseiten-Liste erscheinen und in welcher Reihenfolge (per Ziehen am Griff sortieren). Die Reihenfolge wirkt bei aktivierter Modul-Gruppierung; deaktivierte Bereiche werden vollständig ausgeblendet.',
	settings_start_page_modules_group_title: 'Module',
	settings_start_page_retry: 'Erneut versuchen',
	settings_start_page_section_description: 'Festlegen, welche Module und Kanäle auf der Startseite erscheinen.',
	settings_start_page_tab: 'Startseite',
	settings_theme_app_font_size_caption: 'Aktuelle Größe: %value% pt',
	settings_theme_app_font_size_label: 'Schriftgröße der App',
	settings_theme_btn_color_actions: 'Aktionen-Button',
	settings_theme_btn_color_attach: 'Anhängen-Button',
	settings_theme_btn_color_back: 'Zurück-Button',
	settings_theme_btn_color_copy: 'Kopieren-Button',
	settings_theme_btn_color_delete: 'Löschen-Button',
	settings_theme_btn_color_edit: 'Bearbeiten-Button',
	settings_theme_btn_color_favorite: 'Favorit-Button',
	settings_theme_btn_color_fullscreen: 'Vollbild-Button',
	settings_theme_btn_color_plan: 'Planen-Button',
	settings_theme_btn_color_publish: 'Veröffentlichen-Button',
	settings_theme_btn_color_reset: 'Zurücksetzen',
	settings_theme_btn_color_reset_caption: 'Alle Button-Farben auf Standardwerte zurücksetzen',
	settings_theme_btn_color_reset_title: 'Standardfarben wiederherstellen',
	settings_theme_btn_color_save: 'Speichern-Button',
	settings_theme_btn_color_send: 'Senden-Button',
	settings_theme_btn_color_share: 'Teilen-Button',
	settings_theme_btn_color_spam: 'Spam-Button',
	settings_theme_btn_color_unpublish: 'Verbergen-Button',
	settings_theme_button_color_mode_multi_caption: 'Jede Aktion hat eigene Farbe',
	settings_theme_button_color_mode_multi_label: 'Mehrfarbig',
	settings_theme_button_color_mode_title: 'Button-Farben im Seitenpanel',
	settings_theme_button_color_mode_uni_caption: 'Neutraler einfarbiger Stil',
	settings_theme_button_color_mode_uni_label: 'Einheitlich',
	settings_theme_button_density_compact_caption: 'Nur Icons (Tooltip zeigt Name)',
	settings_theme_button_density_compact_label: 'Kompakt',
	settings_theme_button_density_full_caption: 'Icon + Beschriftung',
	settings_theme_button_density_full_label: 'Mit Label',
	settings_theme_button_density_title: 'Button-Darstellung im Seitenpanel',
	settings_theme_cancel_theme: 'Abbrechen',
	settings_theme_compact_button_view_label: 'Sollen die Buttons beschriftet sein?',
	settings_theme_custom_color_label: 'Eigene Farbe wählen',
	settings_theme_dark_color_label: 'Hintergrundfarbe im dunklen Modus',
	settings_theme_dark_model_caption: 'Hell, Dunkel oder Systemeinstellung folgen',
	settings_theme_dark_model_label: 'Modus',
	settings_theme_delete_theme: 'Löschen',
	settings_theme_description: 'Bearbeiten Sie das Look & Feel Ihrer infra-struktur App.',
	settings_theme_edit_theme_label: 'Theme bearbeiten',
	settings_theme_group_appearance: 'Erscheinungsbild',
	settings_theme_group_button_colors: 'Button-Farben',
	settings_theme_group_color_scheme: 'Farbschema',
	settings_theme_group_theme: 'Farben',
	settings_theme_icon_style_regular_caption: 'Feine Outline-Icons',
	settings_theme_icon_style_regular_label: 'Dünn',
	settings_theme_icon_style_solid_caption: 'Vollflächige Icons',
	settings_theme_icon_style_solid_label: 'Gefüllt',
	settings_theme_icon_style_title: 'Icon-Stil',
	settings_theme_multi_color_buttons_label: 'mehrfarbige Buttons im Seitenpanel',
	settings_theme_primary_color: 'Primärfarbe',
	settings_theme_primary_color_caption: 'Hauptfarbe für Buttons und aktive Elemente',
	settings_theme_primary_color_label: 'Primärfarbe (oberste Leiste)',
	settings_theme_save_theme: 'Speichern',
	settings_theme_secondary_color_label: 'Sekundärfarbe (zweite Leiste)',
	settings_theme_section_description: 'Farben, Erscheinungsbild und visuelle Sprache der App gestalten.',
	settings_theme_selected_theme_label: 'Ausgewähltes Theme',
	settings_theme_soft_shadows_caption: 'Elegante Schatten-Effekte für eine räumliche Tiefe',
	settings_theme_soft_shadows_label: 'Weiche Schatten',
	settings_theme_solid_icons: 'Sollen ausgefüllte Icons benutzt werden?',
	settings_theme_surface: 'Oberfläche',
	settings_theme_surface_caption: 'Basiston für Hintergründe und Flächen',
	settings_theme_tab: 'Darstellung',
	settings_theme_toggle_mode_automatic: 'Automatisch',
	settings_theme_toggle_mode_dark: 'Dunkel',
	settings_theme_toggle_mode_light: 'Hell',
	settings_theme_uni_color_buttons_label: 'einfarbige Buttons im Seitenpanel',
	settings_theme_uni_color_color_label: 'Farbe der einfarbigen Buttons',
	settings_timezone_description: 'Wählen Sie Ihre Zeitzone aus oder lassen Sie diese automatisch bestimmen',

	settings_timezone_selected_automatic_label: 'Automatisch',

	settings_timezone_selected_label: 'Zeitzone',
	settings_user_state_description:
		'Hier können Sie festlegen, an welchen Orten der Aufenthalt in der Benutzer-Online-Liste angezeigt werden soll.',
	settings_user_state_latitude_description: 'Breitengrad',
	settings_user_state_longitude_description: 'Längengrad',

	settings_user_state_radius_description: 'Radius',
	settings_user_state_section_description: 'Orte und automatische Präsenzregeln verwalten.',
	settings_user_state_tab: 'Orte',
	settings_widgets_enabled_caption: 'Zeigt eine Seitenleiste mit Widgets rechts neben der Inbox.',

	settings_widgets_enabled_label: 'Widget-Sidebar anzeigen',
	settings_widgets_limit_reached: 'Maximum erreicht — deaktivieren Sie ein Widget, um ein anderes hinzuzufügen.',

	settings_widgets_picker_caption: 'Maximal 3 Widgets gleichzeitig aktiv.',
	settings_widgets_picker_title: 'Aktive Widgets',
	settings_widgets_section_description: 'Widgets in der Inbox-Seitenleiste konfigurieren und auswählen.',
	settings_widgets_tab: 'Widgets',
	shortcuts_action_cheatsheet_toggle: 'Tastenkürzel-Übersicht',
	shortcuts_action_contact_open: 'Kontaktieren öffnen',
	shortcuts_action_create_appointment: 'Neuer Termin',
	shortcuts_action_create_mail: 'Neue E-Mail',
	shortcuts_action_create_note: 'Neuer Merkzettel',
	shortcuts_action_create_phonecall: 'Neuer Anruf',

	shortcuts_action_create_task: 'Neue Aufgabe',

	shortcuts_action_darkmode_toggle: 'Dunkelmodus umschalten',
	shortcuts_action_detail_delete: 'Geöffnetes Element löschen',
	shortcuts_action_detail_save: 'Geöffnetes Element speichern',
	shortcuts_action_detail_share: 'Geöffnetes Element teilen',
	shortcuts_action_list_favorite_toggle: 'Favorit umschalten',
	shortcuts_action_list_item_next: 'Nächstes Element',
	shortcuts_action_list_item_prev: 'Vorheriges Element',
	shortcuts_action_list_tab_all: 'Tab: Alle',
	shortcuts_action_list_tab_mine: 'Tab: Meine',
	shortcuts_action_list_tab_open: 'Tab: Offen',
	shortcuts_action_mail_create_send: 'Mail senden',
	shortcuts_action_mail_create_send_later: 'Mail später senden',
	shortcuts_action_mail_forward: 'Weiterleiten',
	shortcuts_action_mail_reply: 'Antworten',

	shortcuts_action_mail_reply_all: 'Allen antworten',
	shortcuts_action_mail_spam: 'Als Spam markieren',
	shortcuts_action_nav_calendar: 'Zum Kalender',
	shortcuts_action_nav_documents: 'Zu Dokumenten',
	shortcuts_action_nav_inbox: 'Zur Inbox',
	shortcuts_action_nav_kanban: 'Zum Kanban-Board',
	shortcuts_action_nav_mails: 'Zu E-Mails',
	shortcuts_action_nav_messages: 'Zu Nachrichten',
	shortcuts_action_nav_notes: 'Zu Merkzetteln',
	shortcuts_action_nav_phonecalls: 'Zu Anrufen',
	shortcuts_action_nav_settings: 'Zu Einstellungen',
	shortcuts_action_nav_tasks: 'Zu Aufgaben',
	shortcuts_action_settings_open: 'Einstellungen öffnen',
	shortcuts_action_sidebar_toggle: 'Seitenleiste umschalten',

	shortcuts_action_spotlight_toggle: 'Suche öffnen',
	shortcuts_action_task_delay_day: 'Um 1 Tag verschieben',

	shortcuts_action_task_delay_week: 'Um 1 Woche verschieben',

	shortcuts_badge_destructive: 'Destruktiv',

	shortcuts_cheatsheet_caption: 'Alle aktiven Tastenkürzel auf einen Blick.',
	shortcuts_cheatsheet_empty: 'Keine aktiven Tastenkürzel.',
	shortcuts_cheatsheet_open_settings: 'Einstellungen',
	shortcuts_cheatsheet_search_placeholder: 'Tastenkürzel suchen...',
	shortcuts_cheatsheet_title: 'Tastenkürzel-Übersicht',
	shortcuts_conflict_banner_caption: 'Mehrere Aktionen nutzen dieselbe Tastenkombination. Passen Sie eine davon an.',
	shortcuts_conflict_banner_title: '{count} Konflikt(e) gefunden',

	shortcuts_export_button: 'Exportieren',
	shortcuts_export_caption: 'Speichert alle Zuweisungen als JSON-Datei.',
	shortcuts_export_label: 'Shortcuts exportieren',

	shortcuts_group_bindings: 'Zuweisungen',
	shortcuts_group_data: 'Import / Export',
	shortcuts_group_defaults: 'Zurücksetzen',
	shortcuts_group_master: 'Allgemein',
	shortcuts_import_button: 'Importieren',

	shortcuts_import_caption: 'Lädt Zuweisungen aus einer JSON-Datei.',
	shortcuts_import_error: 'Import fehlgeschlagen — ungültige Datei',

	shortcuts_import_label: 'Shortcuts importieren',
	shortcuts_import_success: 'Shortcuts importiert',
	shortcuts_master_toggle_caption: 'Globaler Schalter — deaktiviert alle Tastenkürzel auf einmal.',
	shortcuts_master_toggle_label: 'Tastenkürzel aktiviert',
	shortcuts_preset_custom: 'Eigene',
	shortcuts_recorder_clear: 'Zurücksetzen',
	shortcuts_recorder_conflict_takeover: 'Kürzel von „{other}“ entfernen und hier verwenden',
	shortcuts_recorder_conflict_warning: 'Kollision mit "{other}". Beim Speichern wird dies zum Konflikt.',
	shortcuts_recorder_escape_hint: 'Esc zum Zurücksetzen. „Übernehmen“ speichert das Kürzel.',
	shortcuts_recorder_label_for: 'Aktion:',
	shortcuts_recorder_press_hint: 'Drücken Sie die gewünschte Tastenkombination',
	shortcuts_recorder_reserved_warning:
		'Diese Tastenkombination ist vom System reserviert und kann nicht verwendet werden.',

	shortcuts_recorder_save: 'Übernehmen',
	shortcuts_recorder_title: 'Tastenkürzel aufzeichnen',
	shortcuts_reset_applied: 'Tastenkürzel zurückgesetzt',
	shortcuts_reset_button: 'Zurücksetzen',
	shortcuts_reset_caption:
		'Setzt alle Tastenkürzel auf die minimale Standard-Auswahl zurück (Spotlight, Einstellungen). Eigene Anpassungen gehen verloren.',
	shortcuts_reset_confirm_accept: 'Zurücksetzen',
	shortcuts_reset_confirm_message:
		'Alle eigenen Anpassungen werden entfernt. Nur Spotlight (⌘K) und Einstellungen (⌘,) bleiben aktiv. Diese Aktion kann nicht rückgängig gemacht werden.',
	shortcuts_reset_confirm_title: 'Tastenkürzel zurücksetzen?',
	shortcuts_reset_label: 'Auf Standard zurücksetzen',

	shortcuts_row_conflict_caption: 'Konflikt — dieselbe Tastenkombination wird mehrfach verwendet.',
	shortcuts_row_record_title: 'Tastenkombination aufzeichnen',

	shortcuts_row_reset_title: 'Auf Standard zurücksetzen',
	shortcuts_row_saved: 'Tastenkürzel gespeichert',
	shortcuts_row_unassigned: 'Nicht zugewiesen',
	shortcuts_scope_all: 'Alle',
	shortcuts_scope_detail: 'Detail',
	shortcuts_scope_global: 'Global',
	shortcuts_scope_list: 'Listen',
	shortcuts_scope_navigation: 'Navigation',

	shortcuts_search_empty: 'Keine Tastenkürzel gefunden.',
	shortcuts_search_placeholder: 'Shortcuts durchsuchen...',
	shortcuts_standard_preset_applied: 'Standard-Belegung angewendet',
	shortcuts_standard_preset_button: 'Anwenden',
	shortcuts_standard_preset_caption:
		'Bewährte Belegung: Navigation per G-Kürzel, J/K in Listen, Speichern & Löschen im Detail. Ersetzt die aktuelle Belegung.',
	shortcuts_standard_preset_confirm_accept: 'Anwenden',
	shortcuts_standard_preset_confirm_message: 'Die Standard-Belegung ersetzt alle aktuellen Tastenkürzel. Fortfahren?',
	shortcuts_standard_preset_confirm_title: 'Standard-Belegung anwenden',
	shortcuts_standard_preset_label: 'Standard-Belegung',
	widgets_active_timer_description: 'Aktuell laufende Zeiterfassung.',
	widgets_active_timer_empty: 'Kein Timer aktiv',
	widgets_active_timer_title: 'Timer',
	widgets_due_tasks_description: 'Aufgaben, die heute oder bald fällig sind.',
	widgets_due_tasks_empty: 'Keine fälligen Aufgaben',
	widgets_due_tasks_overdue: 'Überfällig',
	widgets_due_tasks_this_week: 'Diese Woche',
	widgets_due_tasks_title: 'Fällige Aufgaben',
	widgets_due_tasks_today: 'Heute',
	widgets_ido_favorites_description: 'Ihre favorisierten Akten.',
	widgets_ido_favorites_drop_success_many: '{count} Einträge in «{title}» abgelegt',
	widgets_ido_favorites_drop_success_one: 'In «{title}» abgelegt',
	widgets_ido_favorites_empty: 'Keine Favoriten',
	widgets_ido_favorites_show_all: 'Alle anzeigen ({count})',
	widgets_ido_favorites_show_less: 'Weniger anzeigen',
	widgets_ido_favorites_title: 'Favoriten',
	widgets_loading: 'Wird geladen…',
	widgets_mail_stats_description: 'Unerledigte Einträge nach Modul.',
	widgets_mail_stats_title: 'Offene Posten',
	widgets_pending_alarms_description: 'Anstehende und überfällige Erinnerungen.',
	widgets_pending_alarms_dismiss: 'Bestätigen',
	widgets_pending_alarms_due_now: 'Jetzt fällig',
	widgets_pending_alarms_empty: 'Keine anstehenden Erinnerungen',
	widgets_pending_alarms_title: 'Erinnerungen',
	widgets_pending_alarms_tomorrow: 'morgen',
	widgets_recent_activity_description: 'Ihre zuletzt bearbeiteten Einträge über alle Module.',
	widgets_recent_activity_empty: 'Keine Aktivitäten',
	widgets_recent_activity_title: 'Kürzlich bearbeitet',
	widgets_recent_calls_callback: 'Rückruf erbeten',
	widgets_recent_calls_description: 'Ihre letzten ein- und ausgehenden Anrufe.',
	widgets_recent_calls_empty: 'Keine Anrufe',
	widgets_recent_calls_title: 'Letzte Anrufe',
	widgets_team_status_description: 'Zeigt, wer online ist und welchen Status Ihre Kollegen haben.',
	widgets_team_status_empty: 'Keine Benutzer gefunden',

	widgets_team_status_offline: 'Offline',
	widgets_team_status_title: 'Teamstatus',
	widgets_today_appointments_description: 'Ihre Termine für den heutigen Tag.',
	widgets_today_appointments_empty: 'Keine Termine heute',
	widgets_today_appointments_title: 'Heute anstehend',
};
